// extracted by mini-css-extract-plugin
export default {"billTable":"kisan-bill_billTable__uGG3j","errMsg":"kisan-bill_errMsg__STIU1"};